import React, { Component } from "react"
import PropTypes from "prop-types"

import { Close } from "../components/icons"
import { getContactPopupCookie, setContactPopupCookie } from "../utils/contact-popup"
import ContactPopupForm from "./contact-popup-form"

import DeveloperImage from "../assets/images/developers-popup.jpg"

class ContactPopup extends Component {
  state = {
    contactPopup: false
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const contactPopupCookie = getContactPopupCookie()
    if (contactPopupCookie !== '1') {
      setTimeout(() => {
        this.setState({ contactPopup: true })
        setContactPopupCookie()
      }, 2000)
    }
  }

  render() {
    let {  title, description, image, formIntro, fileDownload } = this.props
    let { contactPopup } = this.state

    return (
      <div className={`popup${contactPopup ? " active" : ""}`}>
        <div className="testimonial-popup__overlay" />
        <div className="testimonial-popup contact-popup">
          <button
            className="contact-popup__close"
            onClick={() => this.setState({ contactPopup: false })}
          >
            <Close color="#FFFFFF" />
          </button>
          <div className="contact-popup__content">
            <img src={image.sourceUrl} alt={image.altText} />
            <div className="contact-popup__text">
              <h4>{title}</h4>
              <p>
                {description}
              </p>
            </div>
          </div>
          <div className="contact-popup__form">
            <ContactPopupForm formIntro={formIntro} download={fileDownload.sourceUrl} />
          </div>
        </div>
      </div>
    )
  }
}

ContactPopup.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  formIntro: PropTypes.string,
  image: PropTypes.shape({
    sourceUrl: PropTypes.string.isRequired,
    altText: PropTypes.string
  }),
  fileDownload: PropTypes.shape({
    sourceUrl: PropTypes.string.isRequired
  })
}

ContactPopup.defaultProps = {
  image: {
    sourceUrl: DeveloperImage,
    altText: 'Contact popup cover'
  }
}

export default ContactPopup
